var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFlickr = function SvgFlickr(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 448",
    style: {
      enableBackground: "new 0 0 448 448"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2196F3"
    },
    cx: 106.667,
    cy: 127.973,
    r: 106.667
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EC407A"
    },
    cx: 341.333,
    cy: 127.973,
    r: 106.667
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M32,426.64c-5.891,0-10.667-4.776-10.667-10.667V330.64c0-17.673,14.327-32,32-32H64 c5.891,0,10.667,4.776,10.667,10.667c0,5.891-4.776,10.667-10.667,10.667H53.333c-5.891,0-10.667,4.776-10.667,10.667v85.333 C42.667,421.864,37.891,426.64,32,426.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M64,362.64H10.667C4.776,362.64,0,357.864,0,351.973s4.776-10.667,10.667-10.667H64 c5.891,0,10.667,4.776,10.667,10.667S69.891,362.64,64,362.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M96,426.64c-5.891,0-10.667-4.776-10.667-10.667V309.307c0-5.891,4.776-10.667,10.667-10.667 c5.891,0,10.667,4.776,10.667,10.667v106.667C106.667,421.864,101.891,426.64,96,426.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M138.667,426.64c-5.891,0-10.667-4.776-10.667-10.667v-64c0-5.891,4.776-10.667,10.667-10.667 s10.667,4.776,10.667,10.667v64C149.333,421.864,144.558,426.64,138.667,426.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M213.333,426.64c-23.564,0-42.667-19.102-42.667-42.667s19.103-42.667,42.667-42.667 c14.984-1.372,29.797,4.027,40.384,14.72c3.652,4.624,2.864,11.334-1.76,14.987c-4.624,3.652-11.334,2.865-14.987-1.76l0,0 c-6.746-5.142-15.203-7.508-23.637-6.613c-11.782,0-21.333,9.551-21.333,21.333s9.551,21.333,21.333,21.333 c8.846,0.479,17.569-2.239,24.576-7.659c4.234-3.978,10.873-3.836,14.933,0.32c4.066,4.148,4.066,10.786,0,14.933 C241.907,422.352,227.773,427.267,213.333,426.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M288,426.64c-5.891,0-10.667-4.776-10.667-10.667V309.307c0-5.891,4.776-10.667,10.667-10.667 c5.891,0,10.667,4.776,10.667,10.667v106.667C298.667,421.864,293.891,426.64,288,426.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M330.667,426.64c-2.831,0.005-5.548-1.115-7.552-3.115l-42.667-42.667 c-4.17-4.162-4.176-10.915-0.014-15.085c0.499-0.5,1.047-0.95,1.636-1.342l32-21.333c4.901-3.27,11.525-1.947,14.795,2.955 s1.947,11.525-2.955,14.795l-21.163,14.123l33.451,33.472c4.159,4.172,4.149,10.926-0.024,15.085 C336.18,425.515,333.482,426.634,330.667,426.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M373.333,426.64c-5.891,0-10.667-4.776-10.667-10.667v-64c0-5.891,4.776-10.667,10.667-10.667 S384,346.082,384,351.973v64C384,421.864,379.224,426.64,373.333,426.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M373.333,405.307c-5.891,0-10.667-4.776-10.667-10.667c0-29.455,23.878-53.333,53.333-53.333 c5.891,0,10.667,4.776,10.667,10.667S421.891,362.64,416,362.64c-17.673,0-32,14.327-32,32 C384,400.531,379.224,405.307,373.333,405.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M139.093,319.973c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667h0.213 c5.891,0,10.667,4.776,10.667,10.667c0,5.891-4.776,10.667-10.667,10.667H139.093z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlickr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flickr.b2237af7.svg";
export { ForwardRef as ReactComponent };